import ExposedLocationList from "./"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import moment from "moment"
import { EXPOSED_LOCATION_LIST } from "../../apollo/queries"

const ExposedLocationListEnhanced = compose(
  withProps((props) => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
      startAt: props.caseStartAt,
      endAt: props.caseEndAt,
    }
  }),
  graphql(EXPOSED_LOCATION_LIST, {
    options: ({ facilityId, caseId, startAt, endAt }) => ({
      variables: { facilityId, caseId, startAt, endAt },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const kase = facility.contactTracingCases[0]

      if (kase.type !== "employeePositive") {
        throw Error("Entity type must be User")
      }

      return {
        userId: kase.subjects[0].entity.id,
        startAt: moment
          .min(
            kase.subjects.map((subject) => moment.parseZone(subject.startAt))
          )
          .format(),
        endAt: moment
          .max(kase.subjects.map((subject) => moment.parseZone(subject.endAt)))
          .format(),
        entities: kase.subjects[0].entity.contactTracingVisits.edges.map(
          (edge) => ({
            id: edge.node.location.id,
            startAt: edge.node.entryAt,
            endAt: edge.node.exitAt,
          })
        ),
        rows: kase.exposedLocations.map((exposedLocation) => ({
          id: exposedLocation.exposed.id,
          name: exposedLocation.exposed.name,
          firstContact: moment.parseZone(exposedLocation.firstContact),
          lastContact: moment.parseZone(exposedLocation.lastContact),
          exposureDuration: moment.duration(
            exposedLocation.exposureDuration,
            "seconds"
          ),
          unit: exposedLocation.exposed.unit.name,
          department: exposedLocation.exposed.department.name,
          compliance:
            exposedLocation.exposed.compliance.timeslices.full.aggregates
              .overall.compliancePercentage,
        })),
      }
    },
  })
)(ExposedLocationList)

ExposedLocationList.propTypes = {
  caseStartAt: PropTypes.string.isRequired,
  caseEndAt: PropTypes.string.isRequired,
}

export default ExposedLocationListEnhanced
